!function(t,n){"object"==typeof exports&&"undefined"!=typeof module?n(exports):"function"==typeof define&&define.amd?define(["exports"],n):n((t="undefined"!=typeof globalThis?globalThis:t||self).htmlToImage={})}(this,(function(t){"use strict";
function n(t,n,e,r){return new(e||(e=Promise))((function(o,i){function u(t){try{f(r.next(t))}catch(t){i(t)}}function c(t){try{f(r.throw(t))}catch(t){i(t)}}function f(t){var n;t.done?o(t.value):(n=t.value,n instanceof e?n:new e((function(t){t(n)}))).then(u,c)}f((r=r.apply(t,n||[])).next())}))}function e(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(i){return function(c){return function(i){if(e)throw new TypeError("Generator is already executing.");for(;u;)try{if(e=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return u.label++,{value:i[1],done:!1};case 5:u.label++,r=i[1],i=[0];continue;case 7:i=u.ops.pop(),u.trys.pop();continue;default:if(!(o=u.trys,(o=o.length>0&&o[o.length-1])||6!==i[0]&&2!==i[0])){u=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){u.label=i[1];break}if(6===i[0]&&u.label<o[1]){u.label=o[1],o=i;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(i);break}o[2]&&u.ops.pop(),u.trys.pop();continue}i=n.call(t,u)}catch(t){i=[6,t],r=0}finally{e=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,c])}}}var r="application/font-woff",o="image/jpeg",i={woff:r,woff2:r,ttf:"application/font-truetype",eot:"application/vnd.ms-fontobject",png:"image/png",jpg:o,jpeg:o,gif:"image/gif",tiff:"image/tiff",svg:"image/svg+xml"};function u(t){var n=function(t){var n=/\.([^./]*?)$/g.exec(t);return n?n[1]:""}(t).toLowerCase();return i[n]||""}function c(t){return-1!==t.search(/^(data:)/)}function f(t,n){return"data:"+n+";base64,"+t}var a,s=(a=0,function(){return a+=1,"u"+("0000"+(Math.random()*Math.pow(36,4)<<0).toString(36)).slice(-4)+a});function l(t){for(var n=[],e=0,r=t.length;e<r;e+=1)n.push(t[e]);return n}function h(t,n){var e=window.getComputedStyle(t).getPropertyValue(n);return parseFloat(e.replace("px",""))}function d(t){return t.toBlob?new Promise((function(n){return t.toBlob(n)})):new Promise((function(n){for(var e=window.atob(t.toDataURL().split(",")[1]),r=e.length,o=new Uint8Array(r),i=0;i<r;i+=1)o[i]=e.charCodeAt(i);n(new Blob([o],{type:"image/png"}))}))}function v(t){return new Promise((function(n,e){var r=new Image;r.onload=function(){return n(r)},r.onerror=e,r.crossOrigin="anonymous",r.decoding="sync",r.src=t}))}function p(t){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,Promise.resolve().then((function(){return(new XMLSerializer).serializeToString(t)})).then(encodeURIComponent).then((function(t){return"data:image/svg+xml;charset=utf-8,"+t}))]}))}))}var g={};function m(t,n){var e=function(t){var n=t.replace(/\?.*/,"");return/ttf|otf|eot|woff2?/i.test(n)&&(n=n.replace(/.*\//,"")),n}(t);if(null!=g[e])return g[e];n.cacheBust&&(t+=(/\?/.test(t)?"&":"?")+(new Date).getTime());var r=window.fetch(t).then((function(t){return t.blob().then((function(n){return{blob:n,contentType:t.headers.get("Content-Type")||""}}))})).then((function(t){var n=t.blob,e=t.contentType;return new Promise((function(t,r){var o=new FileReader;o.onloadend=function(){return t({contentType:e,blob:o.result})},o.onerror=r,o.readAsDataURL(n)}))})).then((function(t){var n,e=t.blob;return{contentType:t.contentType,blob:(n=e,n.split(/,/)[1])}})).catch((function(e){var r="";if(n.imagePlaceholder){var o=n.imagePlaceholder.split(/,/);o&&o[1]&&(r=o[1])}var i="Failed to fetch resource: "+t;return e&&(i="string"==typeof e?e:e.message),i&&console.error(i),{blob:r,contentType:""}}));return g[e]=r,r}function w(t,n,e){var r="."+t+":"+n,o=e.cssText?function(t){var n=t.getPropertyValue("content");return t.cssText+" content: '"+n.replace(/'|"/g,"")+"';"}(e):function(t){return l(t).map((function(n){return n+": "+t.getPropertyValue(n)+(t.getPropertyPriority(n)?" !important":"")+";"})).join(" ")}(e);return document.createTextNode(r+"{"+o+"}")}function b(t,n,e){var r=window.getComputedStyle(t,e),o=r.getPropertyValue("content");if(""!==o&&"none"!==o){var i=s();try{n.className=n.className+" "+i}catch(t){return}var u=document.createElement("style");u.appendChild(w(i,e,r)),n.appendChild(u)}}function y(t){return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return"data:,"===(n=t.toDataURL())?[2,Promise.resolve(t.cloneNode(!1))]:[2,v(n)]}))}))}function P(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,Promise.resolve(t.poster).then((function(t){return m(t,r)})).then((function(n){return f(n.blob,u(t.poster)||n.contentType)})).then((function(t){return v(t)}))]}))}))}function S(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return r instanceof Element?[2,Promise.resolve().then((function(){return function(t,n){var e=window.getComputedStyle(t),r=n.style;r&&(e.cssText?r.cssText=e.cssText:l(e).forEach((function(t){r.setProperty(t,e.getPropertyValue(t),e.getPropertyPriority(t))})))}(t,r)})).then((function(){return function(t,n){b(t,n,":before"),b(t,n,":after")}(t,r)})).then((function(){return function(t,n){t instanceof HTMLTextAreaElement&&(n.innerHTML=t.value),t instanceof HTMLInputElement&&n.setAttribute("value",t.value)}(t,r)})).then((function(){return r}))]:[2,Promise.resolve(r)]}))}))}function x(t,r,o){return n(this,void 0,void 0,(function(){return e(this,(function(i){return o||!r.filter||r.filter(t)?[2,Promise.resolve(t).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return t instanceof HTMLCanvasElement?[2,y(t)]:t instanceof HTMLVideoElement&&t.poster?[2,P(t,r)]:[2,Promise.resolve(t.cloneNode(!1))]}))}))}(t,r)})).then((function(o){return function(t,r,o){var i;return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){var u;return 0===(n=null!=(u=t).tagName&&"SLOT"===u.tagName.toUpperCase()&&t.assignedNodes?l(t.assignedNodes()):l((null!==(i=t.shadowRoot)&&void 0!==i?i:t).childNodes)).length||t instanceof HTMLVideoElement?[2,Promise.resolve(r)]:[2,n.reduce((function(t,n){return t.then((function(){return x(n,o)})).then((function(t){t&&r.appendChild(t)}))}),Promise.resolve()).then((function(){return r}))]}))}))}(t,o,r)})).then((function(n){return S(t,n)}))]:[2,Promise.resolve(null)]}))}))}var E=/url\((['"]?)([^'"]+?)\1\)/g,T=/url\([^)]+\)\s*format\((["'])([^"']+)\1\)/g,C=/src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;function R(t){var n=[];return t.replace(E,(function(t,e,r){return n.push(r),t})),n.filter((function(t){return!c(t)}))}function L(t,n,e,r,o){var i=e?function(t,n){if(t.match(/^[a-z]+:\/\//i))return t;if(t.match(/^\/\//))return window.location.protocol+t;if(t.match(/^[a-z]+:/i))return t;var e=document.implementation.createHTMLDocument(),r=e.createElement("base"),o=e.createElement("a");return e.head.appendChild(r),e.body.appendChild(o),n&&(r.href=n),o.href=t,o.href}(n,e):n;return Promise.resolve(i).then((function(t){return o?o(t):m(t,r)})).then((function(t){return"string"==typeof t?f(t,u(n)):f(t.blob,u(n)||t.contentType)})).then((function(e){return t.replace((r=n.replace(/([.*+?^${}()|\[\]\/\\])/g,"\\$1"),new RegExp("(url\\(['\"]?)("+r+")(['\"]?\\))","g")),"$1"+e+"$3");var r})).then((function(t){return t}),(function(){return i}))}function N(t){return-1!==t.search(E)}function k(t,r,o){return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return N(t)?(n=function(t,n){var e=n.preferredFontFormat;return e?t.replace(C,(function(t){for(;;){var n=T.exec(t)||[],r=n[0],o=n[2];if(!o)return"";if(o===e)return"src: "+r+";"}})):t}(t,o),[2,Promise.resolve(n).then(R).then((function(t){return t.reduce((function(t,n){return t.then((function(t){return L(t,n,r,o)}))}),Promise.resolve(n))}))]):[2,Promise.resolve(t)]}))}))}function A(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(o){return t instanceof Element?[2,Promise.resolve(t).then((function(t){return function(t,r){var o;return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return(n=null===(o=t.style)||void 0===o?void 0:o.getPropertyValue("background"))?[2,Promise.resolve(n).then((function(t){return k(t,null,r)})).then((function(n){return t.style.setProperty("background",n,t.style.getPropertyPriority("background")),t}))]:[2,Promise.resolve(t)]}))}))}(t,r)})).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return t instanceof HTMLImageElement&&!c(t.src)||t instanceof SVGImageElement&&!c(t.href.baseVal)?(n=t instanceof HTMLImageElement?t.src:t.href.baseVal,[2,Promise.resolve(n).then((function(t){return m(t,r)})).then((function(t){return f(t.blob,u(n)||t.contentType)})).then((function(n){return new Promise((function(e,r){t.onload=e,t.onerror=r,t instanceof HTMLImageElement?(t.srcset="",t.src=n):t.href.baseVal=n}))})).then((function(){return t}),(function(){return t}))]):[2,Promise.resolve(t)]}))}))}(t,r)})).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){var n,o;return e(this,(function(e){return n=l(t.childNodes),o=n.map((function(t){return A(t,r)})),[2,Promise.all(o).then((function(){return t}))]}))}))}(t,r)}))]:[2,Promise.resolve(t)]}))}))}var I={};function M(t){var n=I[t];if(null!=n)return n;var e=window.fetch(t).then((function(n){return{url:t,cssText:n.text()}}));return I[t]=e,e}function D(t){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,t.cssText.then((function(n){var e=n,r=/url\(["']?([^"')]+)["']?\)/g,o=(e.match(/url\([^)]+\)/g)||[]).map((function(n){var o=n.replace(r,"$1");return o.startsWith("https://")||(o=new URL(o,t.url).href),window.fetch(o).then((function(t){return t.blob()})).then((function(t){return new Promise((function(r,o){var i=new FileReader;i.onloadend=function(){e=e.replace(n,"url("+i.result+")"),r([n,i.result])},i.onerror=o,i.readAsDataURL(t)}))}))}));return Promise.all(o).then((function(){return e}))}))]}))}))}function V(t){if(null==t)return[];for(var n=[],e=t.replace(/(\/\*[\s\S]*?\*\/)/gi,""),r=new RegExp("((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})","gi");;){if(null===(u=r.exec(e)))break;n.push(u[0])}e=e.replace(r,"");for(var o=/@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi,i=new RegExp("((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})","gi");;){var u;if(null===(u=o.exec(e))){if(null===(u=i.exec(e)))break;o.lastIndex=i.lastIndex}else i.lastIndex=o.lastIndex;n.push(u[0])}return n}function H(t){return t.filter((function(t){return t.type===CSSRule.FONT_FACE_RULE})).filter((function(t){return N(t.style.getPropertyValue("src"))}))}function U(t){return n(this,void 0,void 0,(function(){return e(this,(function(r){return[2,new Promise((function(n,e){null==t.ownerDocument&&e(new Error("Provided element is not within a Document")),n(l(t.ownerDocument.styleSheets))})).then((function(t){return function(t){return n(this,void 0,void 0,(function(){var n,r;return e(this,(function(e){return n=[],r=[],t.forEach((function(n){if("cssRules"in n)try{l(n.cssRules).forEach((function(t,e){if(t.type===CSSRule.IMPORT_RULE){var o=e+1,i=M(t.href).then((function(t){return t?D(t):""})).then((function(t){return V(t).forEach((function(t){try{n.insertRule(t,t.startsWith("@import")?o+=1:n.cssRules.length)}catch(n){console.error("Error inserting rule from remote css",{rule:t,error:n})}}))})).catch((function(t){console.error("Error loading remote css",t.toString())}));r.push(i)}}))}catch(o){var e=t.find((function(t){return null==t.href}))||document.styleSheets[0];null!=n.href&&r.push(M(n.href).then((function(t){return t?D(t):""})).then((function(t){return V(t).forEach((function(t){e.insertRule(t,n.cssRules.length)}))})).catch((function(t){console.error("Error loading remote stylesheet",t.toString())}))),console.error("Error inlining remote css file",o.toString())}})),[2,Promise.all(r).then((function(){return t.forEach((function(t){if("cssRules"in t)try{l(t.cssRules).forEach((function(t){n.push(t)}))}catch(n){console.error("Error while reading CSS rules from "+t.href,n.toString())}})),n}))]}))}))}(t)})).then(H)]}))}))}function j(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,U(t).then((function(t){return Promise.all(t.map((function(t){var n=t.parentStyleSheet?t.parentStyleSheet.href:null;return k(t.cssText,n,r)})))})).then((function(t){return t.join("\n")}))]}))}))}function F(t,n){void 0===n&&(n={});var e=n.width||function(t){var n=h(t,"border-left-width"),e=h(t,"border-right-width");return t.clientWidth+n+e}(t),r=n.height||function(t){var n=h(t,"border-top-width"),e=h(t,"border-bottom-width");return t.clientHeight+n+e}(t);return{width:e,height:r}}function B(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){var o,i,u;return e(this,(function(c){return o=F(t,r),i=o.width,u=o.height,[2,Promise.resolve(t).then((function(t){return x(t,r,!0)})).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,(null!=r.fontEmbedCSS?Promise.resolve(r.fontEmbedCSS):j(t,r)).then((function(n){var e=document.createElement("style"),r=document.createTextNode(n);return e.appendChild(r),t.firstChild?t.insertBefore(e,t.firstChild):t.appendChild(e),t}))]}))}))}(t,r)})).then((function(t){return A(t,r)})).then((function(t){return function(t,n){var e=t.style;n.backgroundColor&&(e.backgroundColor=n.backgroundColor),n.width&&(e.width=n.width+"px"),n.height&&(e.height=n.height+"px");var r=n.style;return null!=r&&Object.keys(r).forEach((function(t){e[t]=r[t]})),t}(t,r)})).then((function(t){return function(t,r,o){return n(this,void 0,void 0,(function(){var n,i,u;return e(this,(function(e){return n="http://www.w3.org/2000/svg",i=document.createElementNS(n,"svg"),u=document.createElementNS(n,"foreignObject"),i.setAttribute("width",""+r),i.setAttribute("height",""+o),i.setAttribute("viewBox","0 0 "+r+" "+o),u.setAttribute("width","100%"),u.setAttribute("height","100%"),u.setAttribute("x","0"),u.setAttribute("y","0"),u.setAttribute("externalResourcesRequired","true"),i.appendChild(u),u.appendChild(t),[2,p(i)]}))}))}(t,i,u)}))]}))}))}var O=16384;function $(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,B(t,r).then(v).then((function(n){var e=document.createElement("canvas"),o=e.getContext("2d"),i=r.pixelRatio||function(){var t,n;try{n=process}catch(t){}var e=n&&n.env?n.env.devicePixelRatio:null;return e&&(t=parseInt(e,10),Number.isNaN(t)&&(t=1)),t||window.devicePixelRatio||1}(),u=F(t,r),c=u.width,f=u.height,a=r.canvasWidth||c,s=r.canvasHeight||f;return e.width=a*i,e.height=s*i,r.skipAutoScale||function(t){(t.width>O||t.height>O)&&(t.width>O&&t.height>O?t.width>t.height?(t.height*=O/t.width,t.width=O):(t.width*=O/t.height,t.height=O):t.width>O?(t.height*=O/t.width,t.width=O):(t.width*=O/t.height,t.height=O))}(e),e.style.width=""+a,e.style.height=""+s,r.backgroundColor&&(o.fillStyle=r.backgroundColor,o.fillRect(0,0,e.width,e.height)),o.drawImage(n,0,0,e.width,e.height),e}))]}))}))}t.getFontEmbedCSS=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,j(t,r)]}))}))},t.toBlob=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,$(t,r).then(d)]}))}))},t.toCanvas=$,t.toJpeg=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,$(t,r).then((function(t){return t.toDataURL("image/jpeg",r.quality||1)}))]}))}))},t.toPixelData=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){var n,o,i;return e(this,(function(e){return n=F(t,r),o=n.width,i=n.height,[2,$(t,r).then((function(t){return t.getContext("2d").getImageData(0,0,o,i).data}))]}))}))},t.toPng=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,$(t,r).then((function(t){return t.toDataURL()}))]}))}))},t.toSvg=B,Object.defineProperty(t,"__esModule",{value:!0})}));

const saveModalBtn = document.getElementById('saveModal')
saveModalBtn.addEventListener('click' , (e) => {
    htmlToImage.toJpeg(document.getElementById('reportModal'), { quality: 0.95 })
  .then(function (dataUrl) {
    var link = document.createElement('a');
    var rptFileName = identifier.patient
    link.download = `${rptFileName}.jpeg`;
    link.href = dataUrl;
    link.click();
  });
    console.log(e);
});

const newWorkBtn = document.querySelector("#worksheets-btn");
newWorkBtn.addEventListener("click", (e) => {
  showPatID();
  console.log(e);
});
function showPatID() {
  document.getElementById("patientId").style.display = "block";
}


const togMenuBtn = document.querySelector("#togMenu");

togMenuBtn.addEventListener("click", (e) => {
  myFunction();
  console.log(e);
});
function myFunction() {
  var x = document.getElementById("navDemo");
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else {
    x.className = x.className.replace(" w3-show", "");
  }
}
function printReport() {
  document.getElementById("nonPrintable").className += "noPrint";
  window.print();
}
const printReportBtn = document.querySelector("#printReport");
printReportBtn.addEventListener("click", (e) => {
  printReport();
  console.log(e);
});

function showReportModal() {
  document.getElementById("reportModal").style.display = "block";
}

window.onclick = function (event) {
  if (
    event.target.id == "id01" ||
    event.target.id == "id02" ||
    event.target.id == "id03" ||
    event.target.id == "id04" ||
    event.target.id == "id05" ||
    event.target.id == "reportModal" ||
    event.target.id == "patientId" ||
    event.target.id == "dhrInput"
  ) {
    document.getElementById(event.target.id).style.display = "none";
  }
};
const history = {
    patID : "",
    
    title: "",
    side : '',
    
    
    symptoms: "",
    custom : '',
    
    
    reportLine :function () {
      history.reportLine = clinReport();
    }
  };
  
  
  const identifier =  {
    patient: "",
    sono : "",
  }
  
  function getPatID() {
  
    document.querySelector("#patIdLine").innerHTML = boldString("Patient Identifier  -  ",'Patient Identifier') + identifier.patient
      document.querySelector("#sonoIdLine").innerHTML = boldString('Sonographer  -  ','Sonographer') + identifier.sono;
       
      document.getElementById("patientId").style.display = "none";
    }
    
    const pDSubBtn = document.querySelector("#patDetSub");
    pDSubBtn.addEventListener("click", (e) => {
      
      identifier.patient = document.getElementById('patDet').value;
      identifier.sono = document.getElementById('sono').value;
      getPatID();
      populate();
      console.log(e);
    });
  
  
   
  const hisCusText = document.querySelector('#hisCus')
  hisCusText.addEventListener("focusout", (e) => {
      history.custom = e.target.value
  });

  const hisSideBtn = document.querySelectorAll(".hisSid");
  hisSideBtn.forEach((button) => {
    button.addEventListener("click", (e) => {
      history.side = e.target.id;
      console.log(e);
    });
  });  
  
  
  const hisSymBtn = document.querySelectorAll(".hisSym");
  hisSymBtn.forEach((button) => {
    button.addEventListener("click", (e) => {
      history.symptoms = e.target.id;
      console.log(e);
    });
  });
  
  
  
  
  function histAge() {
    let today = new Date();
    let currentYear = today.getFullYear();
    let birthYear = document.getElementById("birthyear").value;
    history.age = currentYear - birthYear;
    if (history.age < 120 && history.age > 0) {
      return;
    } else
      while (birthYear == undefined || birthYear == NaN) {
        birthYear = window.prompt(
          "Enter the YEAR OF BIRTH for this PATIENT. Enter a value BETWEEN 1900 and 2020."
        );
      }
    if (birthYear != undefined && birthyear != NaN) {
      history.age = currentYear - birthYear;
    }
  }
  
  
  
  function clinReport() {
    
       {
        history.reportLine =
        history.symptoms  + history.custom
      }
      
  }

  
  function addClin() {
    clinReport();
    document.getElementById("hisTitle").innerHTML = history.title + history.side;
    document.getElementById("hisRpt").innerHTML = boldString("Clinical Details - ","Clinical Details") + `${history.reportLine}`;
   }
  
  /*
  const hisRepBtn = document.querySelector("#hisRep");
  hisRepBtn.addEventListener("click", () => {
    
    addClin();
    showReportModal();
  });
  */


function showCDDiv() {
  var x = document.getElementById('clinDet');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}
function showRLLDiv() {
  var x = document.getElementById('rightLeg');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}
function showLLLDiv() {
    var x = document.getElementById('leftLeg');
    if (x.className.indexOf("w3-show") == -1) {
      x.className += " w3-show";
    } else { 
      x.className = x.className.replace(" w3-show", "");
    }
  }

const rightLeg = {
  impression : 'No DVT. ',
  dvt : '',
  occlusive : '',
  local : '' ,
  prox : '',
  involve : '',
  extension : '',
  dist : '',
  complex : '',
  focal : '',
  other : 'None identified.',
  otherText : '',
  reportLine : function() {
    rightLeg.reportLine = rightLegReport();
  },
}
const rightSup = {
    impression : 'No superficial thrombophlebitis. ',
    involve : '',
    prox : '',
    dist : '',
    
    
    
    reportLine : function() {
        rightSup.reportLine = rightSupReport();
      },

}
const rightBaker = {
    impression : "No Baker's cyst. ",
    dimension : '',
    reportLine : function() {
        rightBaker.reportLine = rightBakerReport();
      },
}
const rightBakBtn = document.querySelectorAll(".rightBak");
rightBakBtn.forEach((button) => {
          button.addEventListener("click", (e) => {
            rightBaker.impression = e.target.id;
            console.log(e);
          });
        });
const rightBakDimText = document.querySelector('#rightBakDimText')
rightBakDimText.addEventListener('focusout', (e) => {
      rightBaker.dimension = e.target.value;
      console.log(e);
})
function rightBakerReport() {
    rightBaker.reportLine = rightBaker.dimension + ' ' +rightBaker.impression
}

function rightSupReport() {
    if (rightSup.impression === 'No superficial thrombophlebitis. ') {
        rightSup.reportLine = rightSup.impression
    } else 
    rightSup.reportLine = 'Superficial thrombophlebitis involving ' +rightSup.involve + ' from ' + rightSup.dist + ' extending to ' +rightSup.prox +  '.'
}
const rightSupProxText = document.querySelector('#rightSupProxText')
rightSupProxText.addEventListener('focusout', (e) => {
      rightSup.prox = e.target.value;
      if (rightSup.prox !== '' || rightSup.dist !== '') {
        rightSup.impression = '';
    }
      console.log(e);
    })
    const rightSupDistText = document.querySelector('#rightSupDistText')
    rightSupDistText.addEventListener('focusout', (e) => {
        rightSup.dist = e.target.value;
        if (rightSup.prox !== '' || rightSup.dist !== '') {
            rightSup.impression = '';
        }
        console.log(e);
      })
const rightSupInvBtn = document.querySelectorAll(".rightSupInv");
rightSupInvBtn.forEach((button) => {
        button.addEventListener("click", (e) => {
          rightSup.involve = e.target.id;
          rightSup.impression = '';
          console.log(e);
        });
      });

const rLLOthBtn = document.querySelectorAll(".rLLOth");
      rLLOthBtn.forEach((button) => {
          button.addEventListener("click", (e) => {
            rightLeg.other = e.target.id;
            console.log(e);
          });
        });
        const rLLOthText = document.querySelector('#rLLOthText')
        rLLOthText.addEventListener('focusout', (e) => {
            rightLeg.otherText = e.target.value;
            rightLeg.impression = '';
            console.log(e);
          })          
const rLLFocalText = document.querySelector('#rLLFocalText')
rLLFocalText.addEventListener('focusout', (e) => {
    rightLeg.complex = e.target.value;
    rightLeg.impression = '';
    console.log(e);
  })
  const rLLProxLocText = document.querySelector('#rLLProxLocText')
  rLLProxLocText.addEventListener('focusout', (e) => {
      rightLeg.prox = e.target.value;
      console.log(e);
    })
    const rLLDistLocText = document.querySelector('#rLLDistLocText')
    rLLDistLocText.addEventListener('focusout', (e) => {
        rightLeg.dist = e.target.value;
        console.log(e);
      })
    const rLLDvtBtn = document.querySelectorAll(".rLLDvt");
    rLLDvtBtn.forEach((button) => {
        button.addEventListener("click", (e) => {
          rightLeg.dvt = e.target.id;
          rightLeg.impression = '';
          console.log(e);
        });
      }); 
      const rLLOccBtn = document.querySelectorAll(".rLLOcc");
      rLLOccBtn.forEach((button) => {
          button.addEventListener("click", (e) => {
            rightLeg.occlusive = e.target.id;
            rightLeg.impression = '';
            console.log(e);
          });
        }); 
        const rLLExtBtn = document.querySelectorAll(".rLLExt");
        rLLExtBtn.forEach((button) => {
            button.addEventListener("click", (e) => {
              rightLeg.local = e.target.id;
              rightLeg.impression = '';
              console.log(e);
            });
          });
          const rLLInvBtn = document.querySelectorAll(".rLLInv");
          rLLInvBtn.forEach((button) => {
              button.addEventListener("click", (e) => {
                rightLeg.involve = e.target.id;
                rightLeg.impression = '';
                console.log(e);
              });
            });
            const rLLProBtn = document.querySelectorAll(".rLLPro");
            rLLProBtn.forEach((button) => {
                button.addEventListener("click", (e) => {
                  rightLeg.extension = e.target.id;
                  rightLeg.impression = '';
                  console.log(e);
                });
              });         
            function rightLegReport() {
                if (rightLeg.dvt === '') {
                    rightLeg.reportLine =  rightLeg.impression
                } else if (rightLeg.local === 'localised ') {
                    rightLeg.reportLine = rightLeg.dvt + ' localised ' + rightLeg.occlusive + ' in the ' + rightLeg.involve + 'extending from '+rightLeg.dist+ ' to '+rightLeg.prox + '.'
                } else {
                    rightLeg.reportLine =  rightLeg.dvt  + rightLeg.occlusive + ' in the ' + rightLeg.involve + '. Distal extent ' + rightLeg.dist + '. Thrombus extends proximally into the ' + rightLeg.extension + ' ' + rightLeg.prox + '. ' + rightLeg.complex 
                }
              
              
           } 

             function addRightLeg() {
               
                rightLegReport();
                rightSupReport();
                rightBakerReport();
                document.getElementById("rightTitleRpt").innerHTML = "Right Leg";
                document.getElementById("rightLegRpt").innerHTML = boldString("Deep Veins  -  ","Deep Veins") + rightLeg.reportLine;
                document.getElementById("rightSupRpt").innerHTML = boldString("Superficial Veins  -  ","Superficial Veins") + rightSup.reportLine;
                document.getElementById("rightBakRpt").innerHTML = boldString("Pop Fossa  -  ","Pop Fossa") + rightBaker.reportLine;
                document.getElementById("rightOthRpt").innerHTML = boldString("Other Abnormality  -  ","Other Abnormality") + rightLeg.other + rightLeg.otherText 
               } 
               const leftLeg = {
                impression : 'No DVT. ',
                dvt : '',
                occlusive : '',
                local : '' ,
                prox : '',
                involve : '',
                extension : '',
                dist : '',
                complex : '',
                focal : '',
                other : 'None identified.',
                otherText : '',
                reportLine : function() {
                  leftLeg.reportLine = leftLegReport();
                },
              }
              const leftSup = {
                  impression : 'No superficial thrombophlebitis. ',
                  involve : '',
                  prox : '',
                  dist : '',
                  
                  
                  
                  reportLine : function() {
                      leftSup.reportLine = leftSupReport();
                    },
              
              }
              const leftBaker = {
                  impression : "No Baker's cyst. ",
                  dimension : '',
                  reportLine : function() {
                      leftBaker.reportLine = leftBakerReport();
                    },
              }
              const leftBakBtn = document.querySelectorAll(".leftBak");
              leftBakBtn.forEach((button) => {
                        button.addEventListener("click", (e) => {
                          leftBaker.impression = e.target.id;
                          console.log(e);
                        });
                      });
              const leftBakDimText = document.querySelector('#leftBakDimText')
              leftBakDimText.addEventListener('focusout', (e) => {
                    leftBaker.dimension = e.target.value;
                    console.log(e);
              })
              function leftBakerReport() {
                  leftBaker.reportLine = leftBaker.dimension + ' ' +leftBaker.impression
              }
              
              function leftSupReport() {
                  if (leftSup.impression === 'No superficial thrombophlebitis. ') {
                      leftSup.reportLine = leftSup.impression
                  } else 
                  leftSup.reportLine = 'Superficial thrombophlebitis involving ' +leftSup.involve + ' from ' + leftSup.dist + ' extending to ' +leftSup.prox +  '.'
              }
              const leftSupProxText = document.querySelector('#leftSupProxText')
              leftSupProxText.addEventListener('focusout', (e) => {
                    leftSup.prox = e.target.value;
                    if (leftSup.prox !== '' || leftSup.dist !== '') {
                      leftSup.impression = '';
                  }
                    console.log(e);
                  })
                  const leftSupDistText = document.querySelector('#leftSupDistText')
                  leftSupDistText.addEventListener('focusout', (e) => {
                      leftSup.dist = e.target.value;
                      if (leftSup.prox !== '' || leftSup.dist !== '') {
                          leftSup.impression = '';
                      }
                      console.log(e);
                    })
              const leftSupInvBtn = document.querySelectorAll(".leftSupInv");
              leftSupInvBtn.forEach((button) => {
                      button.addEventListener("click", (e) => {
                        leftSup.involve = e.target.id;
                        leftSup.impression = '';
                        console.log(e);
                      });
                    });
              
              const lLLOthBtn = document.querySelectorAll(".lLLOth");
                    lLLOthBtn.forEach((button) => {
                        button.addEventListener("click", (e) => {
                          leftLeg.other = e.target.id;
                          console.log(e);
                        });
                      });
                      const lLLOthText = document.querySelector('#lLLOthText')
                      lLLOthText.addEventListener('focusout', (e) => {
                          leftLeg.otherText = e.target.value;
                          leftLeg.impression = '';
                          console.log(e);
                        })          
              const lLLFocalText = document.querySelector('#lLLFocalText')
              lLLFocalText.addEventListener('focusout', (e) => {
                  leftLeg.complex = e.target.value;
                  leftLeg.impression = '';
                  console.log(e);
                })
                const lLLProxLocText = document.querySelector('#lLLProxLocText')
                lLLProxLocText.addEventListener('focusout', (e) => {
                    leftLeg.prox = e.target.value;
                    console.log(e);
                  })
                  const lLLDistLocText = document.querySelector('#lLLDistLocText')
                  lLLDistLocText.addEventListener('focusout', (e) => {
                      leftLeg.dist = e.target.value;
                      console.log(e);
                    })
                  const lLLDvtBtn = document.querySelectorAll(".lLLDvt");
                  lLLDvtBtn.forEach((button) => {
                      button.addEventListener("click", (e) => {
                        leftLeg.dvt = e.target.id;
                        leftLeg.impression = '';
                        console.log(e);
                      });
                    }); 
                    const lLLOccBtn = document.querySelectorAll(".lLLOcc");
                    lLLOccBtn.forEach((button) => {
                        button.addEventListener("click", (e) => {
                          leftLeg.occlusive = e.target.id;
                          leftLeg.impression = '';
                          console.log(e);
                        });
                      }); 
                      const lLLExtBtn = document.querySelectorAll(".lLLExt");
                      lLLExtBtn.forEach((button) => {
                          button.addEventListener("click", (e) => {
                            leftLeg.local = e.target.id;
                            leftLeg.impression = '';
                            console.log(e);
                          });
                        });
                        const lLLInvBtn = document.querySelectorAll(".lLLInv");
                        lLLInvBtn.forEach((button) => {
                            button.addEventListener("click", (e) => {
                              leftLeg.involve = e.target.id;
                              leftLeg.impression = '';
                              console.log(e);
                            });
                          });
                          const lLLProBtn = document.querySelectorAll(".lLLPro");
                          lLLProBtn.forEach((button) => {
                              button.addEventListener("click", (e) => {
                                leftLeg.extension = e.target.id;
                                leftLeg.impression = '';
                                console.log(e);
                              });
                            });         
                          function leftLegReport() {
                              if (leftLeg.dvt === '') {
                                  leftLeg.reportLine =  leftLeg.impression
                              } else if (leftLeg.local === 'localised ') {
                                  leftLeg.reportLine = leftLeg.dvt + ' localised ' + leftLeg.occlusive + ' in the ' + leftLeg.involve + 'extending from '+leftLeg.dist+ ' to '+leftLeg.prox + '.'
                              } else {
                                  leftLeg.reportLine =  leftLeg.dvt  + leftLeg.occlusive + ' in the ' + leftLeg.involve + '. Distal extent ' + leftLeg.dist + '. Thrombus extends proximally into the ' + leftLeg.extension + ' ' + leftLeg.prox + '. ' + leftLeg.complex 
                              }
                            
                            
                         } 
              
                           function addLeftLeg() {
                             
                              leftLegReport();
                              leftSupReport();
                              leftBakerReport();
                              document.getElementById("leftTitleRpt").innerHTML = "Left Leg"
                              document.getElementById("leftLegRpt").innerHTML = boldString("Deep Veins  -  ","Deep Veins") + leftLeg.reportLine;
                              document.getElementById("leftSupRpt").innerHTML = boldString("Superficial Veins  -  ","Superficial Veins") + leftSup.reportLine;
                              document.getElementById("leftBakRpt").innerHTML = boldString("Pop Fossa  -  ","Pop Fossa") + leftBaker.reportLine;
                              document.getElementById("leftOthRpt").innerHTML = boldString("Other Abnormality  -  ","Other Abnormality") + leftLeg.other + leftLeg.otherText 
                             } 
                            
            
             

function boldString(str, substr) {
    var strRegExp = new RegExp(substr, 'g');
    return str.replace(strRegExp, '<b><i>'+substr+'</i></b>');
  }

  const rightLegRepBtn = document.querySelector("#rightLegRep");
  rightLegRepBtn.addEventListener("click", () => {
    addClin();
    addRightLeg();
    checkID();
    showReportModal();
  });
  const leftLegRepBtn = document.querySelector("#leftLegRep");
  leftLegRepBtn.addEventListener("click", () => {
    addClin();
    addLeftLeg();
    checkID();
    showReportModal();
  });
  const reOpenWSBtn = document.querySelector("#savRep");
  reOpenWSBtn.addEventListener("click", () => {
    showReportModal();
  });
  function checkID() {
    if (identifier.patient === '' || identifier.sono === '' ) {
     showPatID();
     
    }
   }
   
   
   function populate() {
     checkID();
     addClin();
    
    showReportModal();
     
     }



